import { useEffect } from 'react';

export const useCommandPaletteHotkey = (onToggle: () => void): void => {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key !== 'k' && event.key !== 'K') return;
      if (!event.metaKey && !event.ctrlKey) return;
      event.preventDefault();
      onToggle();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onToggle]);
};
